import type { Lottery, LotteryDraw } from '@lotta/shared/types-lottery-schemas';
import { getDrawDates } from './get-draw-dates';

type RequiredLotteryProps = Pick<Lottery, 'occurrence' | 'drawDay' | 'drawTime'>;
type RequiredCompletedDrawsProps = Pick<LotteryDraw, 'startDate' | 'endDate' | 'createdAt'>;
type ReturnType = Array<{ startDate: string; endDate: string; drawDate: string }>;

/**
 * For a lottery, get the dates for all its upcoming draws (startDate, endDate, drawDate)
 */
export const getUpcomingDrawDates = ({
  lottery,
  completedDraws,
  timezone,
}: {
  lottery: RequiredLotteryProps;
  completedDraws: Array<RequiredCompletedDrawsProps>;
  timezone: string;
}): ReturnType => {
  const allDraws = getDrawDates(lottery, timezone);
  let upcomingDraws = allDraws;

  if (completedDraws.length > 0) {
    // Sort by draw date descending
    const sortedDraws = [...completedDraws].sort(
      (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf()
    );
    const lastDraw = sortedDraws[0].createdAt;
    upcomingDraws = allDraws.filter(({ drawDate }) => new Date(drawDate) > new Date(lastDraw));
  }

  return upcomingDraws;
};
